export enum AlertType {
    SUCCESS = "SUCCESS"
    , WARNING = "WARNING"
    , DANGER = "DANGER"
    , INFO = "INFO"
    , DISABLED = "DISABLED"
    , NONE = "NONE"
}


export class AlertModel {
    Type: AlertType;
}
